module.exports = __webpack_public_path__ + "76f09558a5194333056d31fd542047e8.png";